<template>
  <v-btn
    text
    dark
    :disabled="disabled"
    @click="$emit('regenerar')"
  >
    CUOTAS NO PAGADAS
    <v-icon right color="white">fas fa-search</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'AnalizadorBtn',
  props: {
    disabled: { type: Boolean, default: false }
  }
}
</script>
